import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Deposit icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Deposit } from '@sravni/design-system-icons'
 *
 * <Deposit />
 * ```
 */
var Deposit = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Deposit", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.013 17.857H2.987a1.565 1.565 0 0 1-1.558-1.571V3.714c0-.868.697-1.57 1.558-1.57h14.026c.861 0 1.559.702 1.559 1.57v12.572c0 .868-.698 1.571-1.559 1.571Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M14.895 15h-9.79a.828.828 0 0 1-.819-.837V5.837c0-.463.367-.837.82-.837h9.79c.452 0 .819.374.819.837v8.326a.828.828 0 0 1-.82.837Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M8.571 11.429a1.429 1.429 0 1 0 0-2.857 1.429 1.429 0 0 0 0 2.857Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M14.643 8.572h2.142M14.643 11.429h2.142M4.286 17.857v1.429M15.715 17.857v1.429", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }))); });

export { Deposit };
//# sourceMappingURL=Deposit.js.map
